








import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'wallet-view',
})
export default class WalletView extends Vue { }
